import { useMutation } from 'react-query';
import { cancelJobAsync } from '../../index';

export const useCancelJobAsync = () => useMutation(cancelJobAsync);
